import type { Environment } from './environment';

export const BUILD_ENVIRONMENT: Environment = 'dev';